import request from '@/utils/request'
import { v2Host } from '@/config/host'
import _ from 'lodash'
import { cookRequestParams } from '@/common/request'

// http://playable.dev.com:8067/?doc=creative/info.go

/**
 * 获取创意方向列表
 * @param {*} params
 */
export function fetchCreativeInfoList(params) {
  // 倒叙输出
  params.order = '-updated_time'
  return request({
    url: `${v2Host}/dmaker/info/list`,
    method: 'get',
    params: params
  })
}

/**
 * 获取创意方向管理列表
 * @param {*} params
 */
export function fetchCreativeMangeList(params) {
  // 倒叙输出
  params.order = '-updated_time'
  return request({
    url: `${v2Host}/dmaker/info/template-list`,
    method: 'get',
    params: cookRequestParams(params)
  })
}

/**
 * 更新创意方向
 * @param {*} params
 */
export function updateCreativeInfo(params) {
  const id = params.id
  params = _.omit(params, ['id'])
  return request({
    url: `${v2Host}/dmaker/info/update?id=${id}`,
    method: 'post',
    data: params
  })
}

/**
 * 新增创意方向
 * @param {*} params
 */
export function createCreativeInfo(params) {
  return request({
    url: `${v2Host}/dmaker/info/create`,
    method: 'post',
    data: params
  })
}

/**
 * 更新创意方向的授权
 * @param {*} params
 */
export function updateCreativeInfoAuth(params) {
  const id = params.id
  params = _.omit(params, ['id'])
  return request({
    url: `${v2Host}/dmaker/info/permission?id=${id}`,
    method: 'post',
    data: params
  })
}
